import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    (async () => {
      if (!sid) { navigate("/connexion"); return; }
      try {
        const { data } = await api.post("/auth/session", { session_id: sid });
        window.history.replaceState(null, "", window.location.pathname);
        setUser(data.user);
        await refresh();
        const u = data.user;
        navigate(u?.effective_permissions?.length ? "/admin" : u?.roles?.includes("secretary") ? "/secretaire" : "/espace");
      } catch {
        navigate("/connexion");
      }
    })();
  }, [navigate, setUser, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="h-10 w-10 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="mt-4 text-slate-500 text-sm">Connexion en cours...</p>
      </div>
    </div>
  );
}
